import React, { Component } from 'react';
import UsersService from '../services/UsersService';

export class ShowUserDetails extends Component {
    constructor(props){
        super(props);
        this.state = {
            users:[],
            errorMessage: ""
        }
    }
    componentDidMount(){
        UsersService.getUsers()
            .then((res)=>{
                this.setState({users:res.data, errorMessage: ""});
            })
            .catch((error) => {
                const status = error?.response?.status;
                const backendMessage =
                    error?.response?.data?.message ||
                    (typeof error?.response?.data === "string" ? error.response.data : null);

                if (status === 401) {
                    this.setState({
                        errorMessage: backendMessage || "Unauthorized. Please login again as admin.",
                    });
                    return;
                }

                this.setState({
                    errorMessage: backendMessage || "Failed to load users.",
                });
            });
    }
  render() {
    return (
    <div>
      <div className='row'>
        {this.state.errorMessage ? (
          <div className="alert alert-danger" role="alert">
            {this.state.errorMessage}
          </div>
        ) : null}
        <table className="table table-bordered table-hover">
            <thead>
                <tr>
                    <th>User Id</th>
                    <th>Phone Number</th>
                    <th>Full Name</th>
                    <th>Email</th>
                </tr>
            </thead>
            <tbody>
                {
                        this.state.users.map( user =>
                            <tr key={user.user_id}>
                                <td>{user.user_id}</td>
                                <td>{user.phone_no}</td>
                                <td>{user.full_name}</td>
                                <td>{user.email}</td>
                            </tr>
                        )
                }
                
            </tbody>
        </table>

      </div>
    </div>
    )
  }
}

export default ShowUserDetails